import { Provider } from '@angular/core';
import { environment } from '@env/environment';
import { API_BASE_URL } from './api-config.token';

/**
 * Provides environment-specific API configuration.
 */
export function provideEnvironment(): Provider[] {
  return [
    {
      provide: API_BASE_URL,
      useValue: environment.apiBaseUrl,
    },
  ];
}
